$mol_view_tree2_to_js_test_ex_structural_quoted_props_foo $mol_object
	bar *
		a$ 1
		b-t *
